function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, cloneElement, useRef, FC, Ref, ElementType, CSSProperties, PropsWithChildren, ReactElement } from 'react';
import cn from 'classnames';
import { useForkRef } from '../../hooks/useForkRef';
import { ITagProps } from '../Tag';
require("./TagsInline.css");
var styles = {
  "Root": "TagsInline-module-Root_3j4",
  "ScrollWrapper": "TagsInline-module-ScrollWrapper_3Vv"
};
export const cnTags = cn('TagsInline');
const initialDimentions = {
  childrenWidth: [],
  childrenHeight: 0,
  columnGap: 0,
  rootWidth: null,
  togglerWidth: 0
};
export const TagsInline = ({
  'aria-label': ariaLabel,
  children,
  className,
  controlRef,
  innerRef,
  style = {},
  tag = 'div',
  ...props
}) => {
  const rootRef = useRef(null);
  const dimentions = useRef(initialDimentions);
  const handleRef = useForkRef(innerRef || controlRef, rootRef);
  const Component = tag;
  dimentions.current.childrenWidth = [];
  return /*#__PURE__*/React.createElement(Component, _extends({
    role: "group",
    "aria-label": ariaLabel,
    style: {
      ...style
    },
    className: cn(styles.Root, className),
    ref: handleRef
  }, props), /*#__PURE__*/React.createElement("div", {
    className: styles.ScrollWrapper
  }, Children.map(children, child => {
    return /*#__PURE__*/cloneElement(child, {
      innerRef: ref => {
        if (ref) {
          dimentions.current.childrenHeight = ref.offsetHeight;
          dimentions.current.childrenWidth.push(ref.offsetWidth);
        }
      }
    });
  })));
};
if (process.env.NODE_ENV !== 'production') {
  TagsInline.displayName = 'TagsInline';
}